function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "950",
  height: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M456.318.267L459.3.77l2.142 1.165 5.729 4.638 1.866 1.176 1.682-.206 7.102-5.617 2.704-1.213 2.092-.49 3.3-.311L454.762 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-1.188 8.02h953.333l.052-7.763-469.579-.04-2.092.491-2.704 1.217-5.036 4.058-2.066 1.577-1.682.206-1.866-1.18-5.73-4.652-2.14-1.168-2.984-.504-457.5-.005",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M950.486.257H483.693c-2.312 0-4.646.624-6.44 2.083l-5.84 4.747c-1.003.816-2.506.813-3.512 0L462.02 2.34c-1.8-1.453-4.129-2.083-6.441-2.083H-1.405",
  stroke: "#979797",
  strokeWidth: ".5",
  fill: "none"
})));